import { useState, useCallback } from 'react';

function useToast() {
    const [toast, setToast] = useState({ message: '', type: '' });

    const showToast = useCallback((message, type = 'success', duration = 3000) => {
        setToast({ message, type });
        setTimeout(() => setToast({ message: '', type: '' }), duration);
    }, []);

    const hideToast = useCallback(() => {
        setToast({ message: '', type: '' });
    }, []);

    return { toast, showToast, hideToast };
}

export default useToast;